import React, { useState } from 'react';
import { View } from 'react-native';
import { useQuery } from '@apollo/client';

import { Button } from 'app/src/elements/buttons';
import { Container, ButtonContainer } from 'app/src/elements/ButtonPicker';
import { Loading } from 'app/src/elements/DataState';
import useToggle from 'app/src/hooks/useToggle';
import { Title, Text } from 'app/src/styles';

import { SUGGEST_THINGS } from './queries';

const SelectButton = ({ thing, selected, onToggle }) => {
  return (
    <ButtonContainer
      onPress={() => onToggle(thing.id)}
      notSelected={!selected}
    >
      <Text style={{ fontSize: 40 }}>
        {thing.emoji || thing.name[0]}
      </Text>
      <Text style={{ fontSize: 12 }}>
        {thing.name}
      </Text>
    </ButtonContainer>
  );
};

const ChooseButton = ({ thing, selected, onToggle }) => {
  return (
    <ButtonContainer
      onPress={() => onToggle(thing.id)}
      notSelected={!selected}
    >
      <Text style={{ fontSize: 60 }}>
        {thing.emoji || thing.name[0]}
      </Text>
      <Text style={{ fontSize: 20 }}>
        {thing.name}
      </Text>
    </ButtonContainer>
  );
};

const Choose = () => {
  const [selectedIds, setSelectedIds] = useState({});
  const [chosenIds, setChosenIds] = useState({});
  const [showSelectedOnly, toggleShowSelectedOnly] = useToggle();

  const { data, loading } = useQuery(SUGGEST_THINGS, {
    variables: { all: true }
  });

  if (!data) { return <Loading />; }

  const things = data.things;

  const toggleSelection = thingId => {
    setSelectedIds(prev => ({ ...prev, [thingId]: !prev[thingId] }));
  };

  const toggleChosen = thingId => {
    setChosenIds(prev => ({ ...prev, [thingId]: !prev[thingId] }));
  };

  const selectedThings = things.filter(thing => selectedIds[thing.id]);
  const displayThings = showSelectedOnly ? selectedThings : things;

  const selectedCount = Object.values(selectedIds).filter(Boolean).length;

  return (
    <View>
      <Title>Choose Things</Title>

      <View style={{ marginVertical: 10 }}>
        <Button
          label={showSelectedOnly ? 'Choose Options' : 'Present Options'}
          onPress={toggleShowSelectedOnly}
          wide
        />
      </View>

      {showSelectedOnly ? (
        <Container>
          {displayThings.map(thing => (
            <ChooseButton
              key={thing.id}
              thing={thing}
              selected={chosenIds[thing.id]}
              onToggle={toggleChosen}
            />
          ))}
        </Container>
      ) : (
        <Container>
          {displayThings.map(thing => (
            <SelectButton
              key={thing.id}
              thing={thing}
              selected={selectedIds[thing.id]}
              onToggle={toggleSelection}
            />
          ))}
        </Container>
      )}
    </View>
  );
};

export default Choose;
